import React from 'react'

const InfoCircleRedSvg = ({ width }) => {
  return (
    <svg xmlns='http://www.w3.org/2000/svg' width={width} viewBox='0 0 14 14'>
      <path
        id='info-circle-svgrepo-com'
        d='M16,9A7,7,0,1,1,9,2,7,7,0,0,1,16,9ZM9,13.025a.525.525,0,0,0,.525-.525V8.3a.525.525,0,1,0-1.05,0v4.2A.525.525,0,0,0,9,13.025ZM9,5.5a.7.7,0,1,1-.7.7A.7.7,0,0,1,9,5.5Z'
        transform='translate(-2 -2)'
        fill='#984C4C'
        fillRule='evenodd'
      />
    </svg>
  )
}

export default InfoCircleRedSvg
